import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import DateRangePicker from "components/widget/DateRangePicker"
import { FileUpload } from "primereact/fileupload"
import { useSelector } from "react-redux"
import { selectCompanyGuid } from "features/auth/authSlice"
import ExpenseItems from "./ExpenseItems"
import { Galleria } from "primereact/galleria"


export default function CostRefundForm({
    formData = {
        title: null,
        dateRange: [null, null],
        expenseItems: [],
        distance: null,
        notes: null,
        errors: [],
        attachments: [], // Aggiungi un array di allegati al formData
    },
    onFormChange = () => { }
}) {

    const [t, i18n] = useTranslation(["global", "absenceReport"])
    const apiUrl = process.env.REACT_APP_API_URL

    // MODES
    const [isKmMode, setKmMode] = useState(formData.isKmMode)
    const [isForfaitMode, setForfaitMode] = useState(formData.isForfaitMode)
    const [isAnalyticMode, setAnalyticMode] = useState(formData.isAnalyticMode)

    let errors = []
    const [title, setTitle] = useState(formData.title)
    const [dateRange, setDateRange] = useState(formData.dateRange);
    const [distance, setDistance] = useState(formData.distance)
    const [expenseItems, setExpenseItems] = useState(formData.expenseItems);
    const [notes, setNotes] = useState(formData.notes);
    const [attachments, setAttachments] = useState(formData.attachments); // Stato per gli allegati


    if (!title) {
        errors.push(t("validation.no_name"))
    }

    if (!dateRange[1]) {
        errors.push(t("validation.no_period"))
    }

    if (isKmMode && (distance < 1 || distance == null)) {
        errors.push(t("absenceReport:validation.no_km"))
    }


    useEffect(() => {
        onFormChange({
            title: title,
            isKmMode,
            isForfaitMode,
            isAnalyticMode,
            dateRange: dateRange,
            distance: distance,
            expenseItems: expenseItems,
            notes: notes,
            errors: errors,
            attachments: attachments,
        })
    }, [title, dateRange, isKmMode, isForfaitMode, isAnalyticMode, distance, expenseItems, notes, attachments])

    // useEffect(() => {
    //     onFormChange({
    //         ...formData,
    //         attachments, // Includi gli allegati nei dati del form
    //     });
    // }, [attachments]);

    const onTemplateSelect = (e) => {
        console.log("Selected files:", e.files);
        setAttachments(e.files); // Salva i file selezionati nello stato
    };

    const onTemplateClear = () => {
        setAttachments([]); // Ripulisci i file
    };



    return (
        <div className="text-start">
            <div className="row mb-4">
                <div className="col-md-10">
                    <input className="form-control" type="text" id="title" name="title" value={title} onChange={(e) => setTitle(e.target.value)} placeholder={t("helper.insert_name")} />
                </div>
            </div>
            <div className="row mb-4">
                <div className="col">
                    <input className="form-check-input" type="checkbox" id="kmMode" name="kmMode" checked={isKmMode} onChange={(e) => {
                        setKmMode(e.target.checked)
                    }} /> <label htmlFor="kmMode"> {t("absenceReport:entity.costRefund.type.distance")}</label>
                </div>
                <div className="col">
                    <input className="form-check-input" type="checkbox" id="forfaitMode" name="forfaitMode" checked={isForfaitMode} onChange={(e) => {
                        setForfaitMode(e.target.checked)
                    }} /> <label htmlFor="forfaitMode"> {t("absenceReport:entity.costRefund.type.forfait")}</label>
                </div>
                <div className="col">
                    <input className="form-check-input" type="checkbox" id="analyticMode" name="analyticMode" checked={isAnalyticMode} onChange={(e) => {
                        setAnalyticMode(e.target.checked)
                    }} /> <label htmlFor="analyticMode"> {t("absenceReport:entity.costRefund.type.analytic")}</label>
                </div>
            </div>
            <div className="row mb-4">
                <div className="col-md-6">
                    < DateRangePicker
                        extDateRange={dateRange}
                        onDateRangePicked={setDateRange} />
                </div>
                <div className={`col-md-4 ${isKmMode ? "null" : "opacity-25"}`}>
                    <input className="form-control" disabled={!isKmMode} placeholder="Distance" type="number" id="distance" name="distance" value={distance} onChange={(e) => setDistance(e.target.value)} />
                </div>
                <div className={`col-md-2 text-start ${isKmMode ? "null" : "opacity-25"}`}>
                    <label htmlFor="distance"> Km</label>
                </div>

            </div>
            {
                isAnalyticMode && (
                    <div className="row mb-4">
                        <span>Allegati</span>
                        <FileUpload
                            name="attachments"
                            customUpload
                            multiple
                            accept="image/*,application/pdf"
                            maxFileSize={1000000}
                            onSelect={onTemplateSelect}
                            onClear={onTemplateClear}
                            emptyTemplate={<p className="m-0">Drag and drop files here to upload.</p>}
                        />

                        < Galleria value={formData.attachments.map(fileName => {
                            return `${apiUrl}/file?file=${fileName}`
                        })} responsiveOptions={[
                            {
                                breakpoint: '991px',
                                numVisible: 4
                            },
                            {
                                breakpoint: '767px',
                                numVisible: 3
                            },
                            {
                                breakpoint: '575px',
                                numVisible: 1
                            }
                        ]} numVisible={5} style={{ maxWidth: '640px' }}
                            item={(item) => {
                                return <img src={item} alt={item.alt} style={{ width: '100%' }} />
                            }} thumbnail={(item) => {
                                return <img src={item} alt={item.alt} style={{ width: '100px' }} />
                            }} />



                    </div>
                )
            }

            {
                isAnalyticMode &&
                <div className="row mb-4">
                    <span>Expense Items</span>
                    <ExpenseItems
                        items={expenseItems}
                        onChange={setExpenseItems}
                    />

                </div>
            }

            <div>
                <label htmlFor="notes">{t("property.notes")}:</label><br />
                <textarea id="notes" className="form-control" name="notes" rows="4" cols="50" value={notes} onChange={(e) => setNotes(e.target.value)} />
            </div>

            <di>
                {errors.map(error => <><span className="text-danger">{error}</span><br /></>)}
            </di>
        </div>

    )
}